<template>
  <div class="contact-view">
    <header>
      <h2>Contact</h2>
    </header>
    <main>
      <ContactPage />
    </main>
    <footer>
      <FooterPage class="footer-page" />
    </footer>
  </div>
</template>

<script>
import FooterPage from '@/components/FooterPage';
import ContactPage from '@/components/ContactPage';

export default {
  name: 'Contact',
  components: {
    ContactPage,
    FooterPage
  }
};
</script>

<style lang="scss" scoped>
.contact-view {
  margin-top: 68px;
  text-align: center;
  padding: 20px 0 0;
  background-color: var(--orange);

  main {
    padding-bottom: 100px;
  }

  header {
    h2 {
      padding: 20px 0 0;
      margin: 0;
    }
  }

  .footer-page {
    position: relative;
    bottom: 0vh;
  }
}

@media screen and (min-width: 1024px) {
  .contact-view {
    margin-top: 80px;
    h2 {
      font-size: 40px;
    }
  }
}
</style>
